import { Helmet } from "react-helmet";
import { Img, Text, Heading, Button } from "../../components";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CustomPrevArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      style={{
        ...style,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        position: "absolute",
        left: "-100px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 2,
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <img
        src="/images/left-arrow.png"
        alt="Previous"
        style={{ width: "20px", height: "40px" }}
      />
    </div>
  );
}

function CustomNextArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      style={{
        ...style,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 2,
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <img
        src="/images/right-arrow.png"
        alt="Next"
        style={{ width: "20px", height: "40px" }}
      />
    </div>
  );
}

export default function Frame1618873025Page() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const sliderRef = React.useRef(null);
  return (
    <>
      <div className="w-full">
        <div className="flex flex-col items-center justify-center gap-[122px] rounded-[80px] bg-black-900 py-[136px] lg:gap-[91px] lg:py-16 xl:gap-[91px] xl:py-8 md:gap-[91px] md:py-5 sm:gap-[61px] sm:py-4">
          <div className="container-xs xl:px-5 lg:px-5 md:px-5">
            <div className="flex flex-col xl:pl-[100px] lg:pl-[100px] gap-[110px] lg:gap-[40px] md:gap-[20px] sm:gap-[10px]">
              <div className="flex items-start md:flex-col xl:mt-[50px]">
                <Heading
                  as="p"
                  className="self-center text-[90px] font-medium uppercase px-5 sm:px-10 text-white-a700 xl:text-[68px] lg:text-[48px] md:text-[48px] md:my-[40px] sm:text-[40px] sm:my-[20px] "
                >
                  TRUST & BEYOND
                </Heading>
                <Img
                  src="images/trust.svg"
                  alt="Close Image"
                  className="mt-3.5 lg:mt-2.5 h-[80px] lg:h-[40px] w-[6%] object-contain md:w-full animate-zoomInOut sm:hidden md:hidden"
                />
              </div>
              <Slider ref={sliderRef} {...settings}>
              <div>
                <CustomPrevArrow
                  onClick={() => sliderRef.current.slickPrev()}
                />
                <div className="mx-28 sm:mx-2 flex items-center justify-between gap-5 md:flex-col md:gap-3 sm:flex-col sm:gap-3">
                  <Img
                    src="images/testimonial-1.jpg"
                    alt="Background Image"
                    className="h-[484px] w-[48%] rounded-[20px] object-contain md:w-full md:h-[300px] sm:w-full sm:h-[300px]"
                  />
                  <div className="flex w-[448] pl-[100px] md:pl-2 sm:pl-3 flex-col items-start gap-10 md:w-full">
                    <Img src="images/trusticon.png" alt=" " className="h-12 w-12 sm:h-10 sm:w-10" />
                    <div className="flex flex-col gap-[26px] self-stretch">
                      <Heading
                        size="text5xl"
                        as="p"
                        className="text-[26px] font-light leading-[38px] text-white-a700 xl:text-[20px] lg:text-[20px] md:text-[22px] sm:text-[20px]"
                      >
                        “Bringing Aaseanar to life online required a team that truly understood our vision, and ZFLOC delivered beyond expectations. They didn’t just build a website; they created an experience that reflects the soul of our brand. Their creativity, attention to detail, and commitment made this journey effortless and inspiring. If you’re looking for a team that builds with heart and precision, ZFLOC is the one.”

                        - <b>Anarkali Marakkar</b>, <i>Indian Film Industry</i>
                      </Heading>
                      {/* <div className="flex items-center gap-[17px]">
                        <Heading
                          size="headingxs"
                          as="h2"
                          className="mb-3 self-end text-[16px] font-semibold tracking-[-0.20px] text-gray-100 lg:text-[13px]"
                        >
                          Anarkali Marakkar
                        </Heading>
                        <Heading
                          as="h3"
                          className="text-[14px] font-normal text-blue_gray-700"
                        >
                          Co-Founder of
                        </Heading>
                        <div className="flex items-start gap-1.5 rounded-[22px] bg-white-a700 p-2">
                          <Img
                            src="images/icon-2.png"
                            alt="Vector Image"
                            className="h-[28px] self-center"
                          />
                          <Img
                            src="images/Waverio.png"
                            alt="Wave Image"
                            className="mt-1 h-[16px] w-[70%] object-contain"
                          />
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="mx-28 sm:mx-2 flex items-center justify-between gap-5 md:flex-col md:gap-3 sm:flex-col sm:gap-3">
                    <Img
                      src="images/testimonial-2.jpeg"
                      alt="Background Image"
                      className="h-[484px] w-[48%] rounded-[20px] object-contain md:w-full md:h-[300px] sm:w-full sm:h-[300px]"
                    />
                    <div className="flex w-[448] pl-[100px] md:pl-2 sm:pl-3  flex-col items-start gap-10 md:w-full">
                      <Img src="images/trusticon.png" alt="" className="h-12 w-12 sm:h-10 sm:w-10" />
                      <div className="flex flex-col gap-[26px] self-stretch">
                        <Heading
                          size="text5xl"
                          as="p"
                          className="text-[26px] font-light leading-[38px] text-white-a700 xl:text-[20px] lg:text-[20px] md:text-[22px] sm:text-[20px]"
                        >
                          &quot; I am truly impressed by Zfloc Technologies' quality of service. The team delivered the AI agent for classteam is flawless, meeting deadlines while maintaining professionalism. Their expertise has significantly enhanced our project, and I look forward to working with them again.&quot;- <b>Georgekutty George</b>, <i>CEO Classteam</i>
                        </Heading>
                        {/* <div className="flex items-center gap-[17px]">
                          <Heading
                            size="headingxs"
                            as="h2"
                            className="mb-3 self-end text-[16px] font-semibold tracking-[-0.20px] text-gray-100 lg:text-[13px]"
                          >
                            Jenny Wilson
                          </Heading>
                          <Heading
                            as="h3"
                            className="text-[14px] font-normal text-blue_gray-700"
                          >
                            Co-Founder of
                          </Heading>
                          <div className="flex items-start gap-1.5 rounded-[22px] bg-white-a700 p-2">
                            <Img
                              src="images/icon-2.png"
                              alt="Vector Image"
                              className="h-[28px] self-center"
                            />
                            <Img
                              src="images/Waverio.png"
                              alt="Wave Image"
                              className="mt-1 h-[16px] w-[70%] object-contain"
                            />
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <CustomNextArrow
                      onClick={() => sliderRef.current.slickNext()}
                    />
                  </div>
              </div>
              </Slider>
            </div>
          </div>
          <div className="mb-1 flex w-[78%] flex-col gap-[62px] xl:w-full xl:px-5 lg:w-full lg:px-5 md:w-full md:px-5 sm:gap-[31px]">
            <div className="flex items-center justify-center w-full">
              <div className="flex items-center gap-4 w-full max-w-[800px]">
                <div className="flex-grow h-[1px] bg-gray-300"></div>
                <Heading
                  as="h4"
                  className="text-gray-300 uppercase text-[20px]"
                >
                  Trusted By
                </Heading>
                <div className="flex-grow h-[1px] bg-white-a700"></div>
              </div>
            </div>
            <div className="relative w-full overflow-hidden bg-black py-5">
              <div className="flex min-w-max animate-marquee1">
                {[...Array(2)].flatMap(() => [
                  "aaseanar.svg",
                  "mozhi.svg",
                  "lookings.svg",
                  "leadlytics.svg",
                  "Oppam-1.svg",
                  "ElectronicVillage.svg",
                  "2Hat.svg",
                  "Talkiko-1.svg",
                  "DreamPG.svg",
                  "bigformula.svg",
                ]).map((image, index) => (
                  <img
                    key={index}
                    src={`images/${image}`}
                    alt={`Partner ${index + 1}`}
                    className="h-[45px] w-auto object-contain filter grayscale mx-4"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
